import React, { PureComponent } from "react";
import Popup from "./Popup.js";
import Button from "../Button/Button.js";
import Constants from '../Constants.js';
import PlatformTest from '../PlatformTest.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
library.add(faStar);
library.add(faHeart);



class PopupRateApp extends PureComponent {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.popup = React.createRef();
    }

    show() {
        this.popup.current.show();
    }
    hide() {
        this.popup.current.hide();
    }

    render() {

        return (
            <Popup
                ref={this.popup}
                showing={false}
            >
                <h1 className="Title">
                    Enjoying {Constants.name}?
                </h1>
                <div className="Wrapper">
                    <FontAwesomeIcon
                        className="HeartIcon"
                        icon="heart"
                    />
                </div>
                <p className="Paragraph">
                    Consider leaving a rating—it really helps! {(!this.props.data.rated && PlatformTest.ios()) && 'Also, you\'ll get a few free hints as a little thank-you ;)'}
                </p>


                <div
                    style={{
                        display: 'inline-block',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        onClick={() => {

                            let data = this.props.data;

                            // If they haven't rated the game, mark that they have and give them 3 hints
                            // Note: removed hint reward from Android to comply with guidelines
                            if (!data.rated && PlatformTest.ios()) {
                                data.rated = true;
                                data.hintsRemaining = data.hintsRemaining + 3;
                                console.log('data after:', data);
                                if (typeof this.props.onUpdateData === 'function')
                                    this.props.onUpdateData(data);
                            }

                            // If LaunchReview exists
                            if (window.LaunchReview) {
                                // If in-app rating is supported, show the window
                                if (window.LaunchReview.isRatingSupported()) {
                                    window.LaunchReview.rating();
                                }
                                // Else, launch the app store and prompt for rating
                                else {
                                    window.LaunchReview.launch();
                                }
                            }

                            // Hide popup
                            this.hide();
                        }}
                    >
                        <FontAwesomeIcon className="ButtonIcon" icon={faStar} />
                        Rate {Constants.name}
                    </Button>
                    <div
                        className="Price"
                    >
                        {(!this.props.data.rated && PlatformTest.ios()) && '+3 FREE Hints'}
                    </div>
                </div>
            </Popup>
        );
    }
}

export default PopupRateApp;
